import { render } from "./loft.svg?vue&type=template&id=dd70d438"
const script = {}
script.render = render

export default script